import NextLink, { LinkProps as NextLinkProps } from 'next/link'

interface LinkProps extends NextLinkProps {
    className?: string // Add the className prop here
    target?: string
}
const Link: React.FC<LinkProps> = ({ href, children, ...props }) => {
    return (
        <NextLink href={href}>
            <a {...props}>{children}</a>
        </NextLink>
    )
}

export default Link
